import { Icon } from '@gerdau/hefesto/Icon';
import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import GoBackButton from '../../../components/GoBackButton';
import { loadOpenOrderStatusBySku } from '../../../store/ducks/dashboard/actions';
import { IOpenOrderStatusState } from '../../../store/ducks/dashboard/types';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { ErrorIcon, ItemContainerError } from '../styles';
import OpenOrderStatusBySkuTable from './OpenOrderStatusBySkuTable';
import { Container, DashboardItemContainer, Header } from './styles';
import Skeleton from 'react-loading-skeleton';

interface IOpenOrderStatusBySkuProps {
  openOrderStatusState: IOpenOrderStatusState;
  selectedCustomerId: string;
  backToDashboard(): void;
  customerType: ECustomerTypeView;
}

const OpenOrderStatusBySku: React.FC<IOpenOrderStatusBySkuProps> = ({
  openOrderStatusState,
  selectedCustomerId,
  backToDashboard,
  customerType
}) => {
  const dispatch = useDispatch();

  return (
    <Container>
      <Header>
        <GoBackButton title="Voltar" onClick={backToDashboard} />

        <Title level={2}>Volume de sku por status (T)</Title>

        {openOrderStatusState.lastUpdateMomentBySku && (
          <span>
            Atualizado em:{' '}
            <strong>
              {openOrderStatusState.lastUpdateMomentBySku?.format(
                'DD/MM/YYYY, HH:mm'
              )}
            </strong>
          </span>
        )}
      </Header>

      <DashboardItemContainer className="no-norder">
        {openOrderStatusState.loadingBySku &&
          !openOrderStatusState.erroBySku && (
            <Skeleton
              count={10}
              width={'98.5%'}
              style={{ margin: '0.5rem 0' }}
            />
          )}

        {!openOrderStatusState.loadingBySku &&
          !openOrderStatusState.erroBySku && (
            <OpenOrderStatusBySkuTable
              openOrderStatusState={openOrderStatusState}
            />
          )}

        {openOrderStatusState.erroBySku && (
          <ItemContainerError>
            <ErrorIcon />
            <span>
              Não foi possível carregar os status por sku.
              <br />
              Por favor, tente novamente mais tarde.
            </span>
            <Button
              name="try-again"
              variant="primary"
              icon={<Icon option="Settings" />}
              iconPosition="left"
              onClick={() => {
                dispatch(
                  loadOpenOrderStatusBySku(selectedCustomerId, customerType)
                );
              }}
              loading={openOrderStatusState.loading}
            >
              Tentar novamente
            </Button>
          </ItemContainerError>
        )}
      </DashboardItemContainer>
    </Container>
  );
};

export default OpenOrderStatusBySku;
